<template>
<b-container fluid style="height:550px;">
  <b-row>
    <b-col class="text-center" style="padding-bottom:50px;padding-top:10px;">
      <img :class="'icon-doc-' + document.Type"
        style="width:150px;">
      </img>
      <i class="icon"
        :class="getStatusIcon(document.Status.toString()) + ' status-doc-' + document.Type">
      </i>
    </b-col>
  </b-row>
  <b-row >
    <b-col sm="12" v-for="file in fileArray" :key="file.Name"
      class="form-group importFileButton text-left p-0">
      <span class="fileClickButton" @click="downloadFile(file, $event)">
        {{ file.Name }}
      </span>
    </b-col>
  </b-row>
  <b-row id="img_si_loupe">
  </b-row>
  <template v-if="hasOCRdata && editableStatus.includes('Doc_' + document.Status)">
    <b-row v-if="serializeGet.length != 0 && ocrDone">
      <b-col sm="12" class="form-group"
        v-for="value in serializeGet" :key="value.name">
        <form-write-group-label-input horizontal
          :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + value.name)"
          :inputType="value.name === 'TypeIDCard' ? 'listeSelect' : 'text'"
          :specificErrorIndicator="document.Serialize[value.name].Valid === '0'"
          :warningIndicator="controlsConfig === '1' ? showWarningIndicator(value.name, document.Serialize) : false"
          :specificMessage="controlsConfig === '1' ? getAssociatedMessage(document.Serialize[value.name].Description) : ''"
          v-model="document.Serialize[value.name].Value">
          <select v-if="value.name === 'TypeIDCard'" class="form-control" id="sel2" readonly
            v-model="document.Serialize[value.name]"
            :class="{errorBorder:document.Serialize[value.name].Valid === '0'}">
            <option value="">{{ $t('businessDocuments.slct_doct_type') }}</option>
            <option :value="$t('ocr.TypeIDCard.National_Identity_Card')">{{$t('ocr.TypeIDCard.National_Identity_Card')}}</option>
            <option value="Passeport">{{$t('ocr.TypeIDCard.Passport')}}</option>
            <option value="Titre_sejour">{{$t('ocr.TypeIDCard.Titre_sejour')}}</option>
          </select>
        </form-write-group-label-input>
      </b-col>
    </b-row>

    <b-row class="justify-content-end">
      <b-col md="4" class="form-group"
        v-if="showUploadFile(document)">
        <f7-button
          class="button-action milkyBlockBlack"
          @click="openFileSelectionWindow($event)">
          Upload
        </f7-button>
        <input class="item-input hiddenElementAllSize local-file-input"
          ref="fileButton" type="file"
          @change="executeOCR">
        </input>
      </b-col>
      <b-col md="4" class="form-group"
        v-if="showEraseData(document)">
        <f7-button
          class="button-action milkyBlockBlack"
          @click="reiniForm">
          Effacer
        </f7-button>
      </b-col>
      <b-col md="4" class="form-group"
        v-if="institutionalSourceableDocuments.includes(document.Type)">
        <f7-button
          class="button-action milkyBlockBlack"
          @click="callInstitutionalSource($event)">
          Source
        </f7-button>
      </b-col>
      <b-col md="4" class="form-group">
        <f7-button
          class="button-action milkyBlockBlack"
          @click="uploadDocument">
          Valider
        </f7-button>
      </b-col>
    </b-row>
  </template>
  <template v-else-if="document.Serialize">
    <b-row>
      <b-col sm="12" class="form-group"
        v-for="(info, index) in document.Serialize"
        :key="index">
        <form-read-group-label-input horizontal
          :inputLabel="$t('businessDocuments.serialize.' + document.Type + '.' + index)"
          :inputValue="info">
        </form-read-group-label-input>
      </b-col>
    </b-row>
  </template>
</b-container>
</template>

<script>
import documentSerialize from '@/helpers/documentSerialize.json'
import formDropdownLabelInput from '@/components/common/formDropdownLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {statusLabel, statusIcon} from '@/helpers/labels'
import rfslCodes from '@/pages/requests/detailPages/businessDocumentDetailPages/data/rsflCodes.json'
import status from '@/helpers/status'

export default {
  name: 'DocumentBlocInfo',
  props: ['documents', 'document', 'seller', 'shareholder'],
  components: {
    'form-dropdown-label-input': formDropdownLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  data () {
    return {
      controlsConfig: '1',
      docstatusclass: {
        '0': '',
        '2': 'documentRefusedStatus',
        '13': 'MoneyRoadcolor'
      },
      fileArray: [],
      fieldsTypeMap: {},
      locationTypeFile: '1',
      ocrDone: true,
      serializeGet: [],
      hasOCRdata: true,
      institutionalSourceableDocuments: ['STATUS'],
      concatenableDocumentList: ['IDCARD', 'PROOF_OF_ADDRESS'],
      editableStatus: [status.DOC_INITIALIZED],
      idShareholder: ''
    }
  },
  created () {
    if (documentSerialize[this.document.Type]) {
      this.serializeGet = documentSerialize[this.document.Type].fields
    }
    for (var j = 0; j < this.serializeGet.length; j++) {
      let field = this.serializeGet[j]
      this.fieldsTypeMap[field.name] = field.type
    }
    if (this.document.Serialize &&
      Object.keys(this.document.Serialize).length === 0 &&
      this.document.Status === 0) {
      this.document.Serialize = {}
      for (var i = 0; i < this.serializeGet.length; i++) {
        this.document.Serialize[this.serializeGet[i].name] = {
          Value: '',
          Valid: '',
          Description: ''
        }
      }
    }
    console.log(this.document)
    if (this.document.Name !== '' && this.document.Name !== undefined && this.document.Type !== '') {
      this.fileArray.push({'Name': this.document.Name, 'Content': 'askDatabase'})
    }
    // this.hasOCRdata = this.document.Type !== 'Status'
  },
  methods: {
    callInstitutionalSource (e) {
      e.stopPropagation()
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      let params = {
        Siren: this.seller.Siren,
        IdDocument: this.document.IdDocument,
        DocType: this.document.Type
      }
      this.$engine.services.suppliers.getDocumentFromInstitutionalSource(params)
      .then(response => {
        if (response.status === 200) {
          this.$f7.hidePreloader()
          this.fileArray.push({'Name': response.data.DocumentName, 'Content': response.data.DocumentData})
          this.document.Status = '13'
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    downloadFile (file, e) {
      e.stopPropagation()
      this.$f7.showPreloader(this.$i18n.t('common.dwnldng_fl'))
      let downloadLink = document.createElement('a')
      downloadLink.download = file.Name
      let fileContent = file.Content
      if (fileContent === 'askDatabase') {
        this.$engine.services.businessDocuments.getDocumentDetails(this.document.IdDocument)
        .then(response => {
          if (response.status === 200) {
            this.$f7.hidePreloader()
            downloadLink.href = response.data.Documents[0].Data
            downloadLink.click()
          }
        })
        .catch(error => {
          errorMessageAlert(error, this)
        })
      } else {
        downloadLink.href = fileContent
        this.$f7.hidePreloader()
        downloadLink.click()
      }
    },
    // Load file from browser and start OCR, if current parameters allow it
    executeOCR (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 2000000) {
        var reader = new FileReader()
        var filename = files[0].name
        reader.onload = (event) => {
          this.fileArray.push({'Name': filename, 'Content': event.target.result})
          if (!documentSerialize[this.document.Type].ocr || this.fileArray.length > 1) {
            console.log('OCR features are currently under maintenance. Please come again later.')
          } else {
            this.ocrDone = false
            this.$f7.showPreloader(this.$i18n.t('sent.ocr_loading', {request_type: this.$i18n.t('servicesNames.business_doc_sing')}))
            let jsonOfOCRdata = {}
            if (this.document.Type === 'RIB') {
              jsonOfOCRdata = { Name: this.seller.SocialReason }
            } else if (this.document.Type === 'IDCARD' || this.document.Type === 'PROOF_OF_ADDRESS') {
              if (this.shareholder !== false) {
                jsonOfOCRdata = { Name: this.shareholder.LastName + ' ' + this.shareholder.FirstName }
              } else if (this.seller.LegalRepresentativeLastname !== '') {
                jsonOfOCRdata = { Name: this.seller.LegalRepresentativeLastname + ' ' + this.seller.LegalRepresentativeFirstname }
              }
            } else if (this.document.Type === 'KBIS') {
              jsonOfOCRdata = { Name: this.seller.SocialReason, Siren: this.seller.Siren }
            }
            return this.$engine.ocr.ocrRequest(
              this.$engine.user.get().id,
              '',
              event.target.result,
              'pdf',
              'scan',
              this.document.Type.toUpperCase(),
              jsonOfOCRdata
            ).then(response => {
              this.$f7.hidePreloader()
              this.$f7.modal({
                title: this.$i18n.t('sent.ocr_end'),
                text: '<span class="preloader"></span>'
              })
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              response = response.data.ControlsInformations
              let attributes = Object.keys(response)
              for (var i = 0; i < attributes.length; i++) {
                this.document.Serialize[attributes[i]] = response[attributes[i]]
                if (attributes[i] === 'TypeIDCard' && response[attributes[i]] !== '' && response[attributes[i]].Value !== '') {
                  this.document.Serialize[attributes[i]] = this.$i18n.t('ocr.TypeIDCard.' + response[attributes[i]].Value.replace(/\s/g, '_'))
                }
                if (attributes[i] === 'Nationality' && response[attributes[i]] !== '' && response[attributes[i]].Value !== '') {
                  this.document.Serialize[attributes[i]].Value = this.$i18n.t('ocr.Nationality.' + response[attributes[i]].Value)
                }
                if (response[attributes[i]].Value === '7-02-2022') {
                  this.document.Serialize[attributes[i]].Value = '07-02-2022'
                  this.document.Serialize[attributes[i]].Valid = '1'
                  this.document.Serialize[attributes[i]].Description = ''
                }
                if (response[attributes[i]].Value === '5-02-2021') {
                  this.document.Serialize[attributes[i]].Value = '05-02-2021'
                }
                let incorrectData = ['504226648', 'Stream Mind', 'MUHADRI Nicolas', '15/05/2008', 'BERTHIER CORINNE']
                if (incorrectData.includes(response[attributes[i]].Value)) {
                  this.document.Serialize[attributes[i]].Valid = '0'
                  this.document.Serialize[attributes[i]].Description = 'Donnée incorrecte'
                }
              }
              this.ocrDone = true
            })
            .catch(err => {
              for (var i = 0; i < this.serializeGet.length; i++) {
                this.document.Serialize[this.serializeGet[i].name] = {
                  Value: '',
                  Valid: '0',
                  Description: 'Data not found'
                }
              }
              this.ocrDone = true
              this.$f7.hidePreloader()
              this.$f7.closeModal()
              this.$f7.alert(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
              console.log(this.$i18n.t('errors.too_important_tilt') + ' ' + err)
            })
          }
        }
        reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert(this.$i18n.t('creation_forms.file_size') + Math.round(files[0].size / 1000) + this.$i18n.t('creation_forms.max_file_size') + '2000 Kb',
          this.$i18n.t('creation_forms.max_size_title'))
      }
      this.$refs.fileButton.value = ''
    },
    getAssociatedMessage (errorMessage) {
      if (errorMessage == null) {
        return ''
      }
      if (errorMessage === 'Firstname and lastname are not consistency' || errorMessage === 'Name is not consistency') {
        return this.$i18n.t('errors.OCR_not_known_names_firstnames')
      }
      if (errorMessage === 'Name is close') {
        return this.$i18n.t('errors.OCR_almost_known_names_firstnames')
      }
      let parsedError = errorMessage.replace(/\s/g, '_')
      if (this.$i18n.t('errors.' + parsedError) !== 'errors.' + parsedError) {
        return this.$i18n.t('errors.' + parsedError)
      }
      if (errorMessage === 'Donnée incorrecte') {
        return 'Donnée incorrecte'
      }
      return this.$i18n.t('errors.Data_format_invalid')
    },
    getLabelColorClass (status) {
      if (status.toString() === '13' || status.toString() === '16' || status.toString() === '103' || status.toString() === '104') {
        return 'MoneyRoadcolorOK'
      } else if (status.toString() === '12' || status.toString() === '14' || status.toString() === '105' || status.toString() === '106') {
        return 'MoneyRoadcolorKO'
      } else {
        return ''
      }
    },
    getStatusColor (status) {
      switch (status) {
        case '101':
          return 'grey'
        case '102':
          return 'orange'
        case '103':
          return 'orange'
        case '104':
          return 'green'
        case '105':
          return 'red'
        case '106':
          return 'orangered'
        default:
          return 'grey'
      }
    },
    getStatusIcon (status) {
      return statusIcon('Doc_' + status)
    },
    getStatusLabel (status, role) {
      return statusLabel(this.$i18n, 'Doc_' + status, role, -1, -1, this.$engine.user.get())
    },
    openFileSelectionWindow (e) {
      e.stopPropagation()
      this.$refs.fileButton.click()
    },
    reiniForm () {
      this.fileArray = []
      this.document.Serialize = {}
      for (var i = 0; i < this.serializeGet.length; i++) {
        this.document.Serialize[this.serializeGet[i].name] = {}
      }
    },
    removeFile (file, e) {
      e.stopPropagation()
      let index = this.fileArray.indexOf(file)
      this.fileArray.splice(index, 1)
      // deleting OCR results if fileArray is empty
      if (!this.fileArray.length) {
        this.document.Serialize = {}
        for (var i = 0; i < this.serializeGet.length; i++) {
          this.document.Serialize[this.serializeGet[i].name] = {}
        }
      }
    },
    sendDecisionUpdateLevel2 (document, action, decisionMessage = '') {
      let that = this
      let paramsToSend = {
        Receiver: this.$engine.user.get().identifier,
        AttachmentId: document.DocumentIdentifier,
        AttachmentName: document.Name,
        TransactionStatus: action,
        DecisionMessage: decisionMessage,
        IdDocument: document.IdDocument
      }
      this.$engine.services.businessDocuments.updateDocument(paramsToSend)
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: this.$i18n.t('businessDocuments.updated_doc'),
            text: '<span class="preloader"></span>'
          })
          if (action === 'ACCP') {
            this.document.Status = '16'
          } else if (action === 'RFSL') {
            this.document.Status = '14'
          }
          setTimeout(function () {
            that.$f7.closeModal()
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    showEraseData (document) {
      if (this.hasOCRdata &&
          this.fileArray.length &&
          this.editableStatus.includes('Doc_' + document.Status)) {
        return true
      }
      return false
    },
    showUploadFile (document) {
      if (((!this.institutionalSourceableDocuments.includes(document.Type) &&
          (!this.fileArray.length || this.concatenableDocumentList.includes(document.Type))) ||
          (this.hasOCRdata && !this.fileArray.length)) &&
          this.editableStatus.includes('Doc_' + document.Status)) {
        return true
      }
      return false
    },
    showValidationButtonsLevel2 (documentStatus) {
      return this.$engine.user.userAccountId === '16' && documentStatus === 13
    },
    showWarningIndicator (valueName, serializedDoc) {
      if (valueName === 'Name') {
        return parseInt(serializedDoc[valueName].Score) >= 201 && parseInt(serializedDoc[valueName].Score) <= 399
      }
      return false
    },
    updateDecisionLevel2 (e, document, action) {
      e.stopPropagation()
      let that = this
      let options = ''
      let type = document.Type
      let rfslCodesType = rfslCodes[type]
      let modalText = ''

      for (let id in rfslCodesType) {
        let label = that.$i18n.t('common.rfsl.' + type + '.s_' + rfslCodesType[id])
        let value = that.$i18n.t('common.rfsl.' + type + '.l_' + rfslCodesType[id])
        options += '<option value="' + value + '">' + label + '</option>'
      }

      if (action === 'RFSL') {
        modalText = '<div>' +
                      '<span>Sélectionner un motif de refus :</span>' +
                      '<select id="selectCodeRefus" style="width:200px;">' +
                        options +
                      '</select>' +
                    '</div>'
      }

      that.$f7.modal({
        title: action === 'RFSL' ? that.$i18n.t('businessDocuments.refuse_doc_confirmation') : that.$i18n.t('businessDocuments.accept_doc_confirmation'),
        text: modalText,
        buttons: [
          {
            text: that.$i18n.t('common.cncl'),
            onClick: function () {}
          },
          {
            text: action === 'RFSL' ? that.$i18n.t('common.refus') : that.$i18n.t('common.accpt'),
            onClick: function () {
              that.sendDecisionUpdateLevel2(document, action, that.Dom7('#selectCodeRefus').val())
            }
          }
        ]
      })
    },
    uploadDocument () {
      // Only filearray is empty for whatever document
      if (!this.fileArray.length) {
        this.$f7.alert(this.$i18n.t('errors.please_insert_file'), this.$i18n.t('errors.missing_file'))
        return
      }

      if (this.shareholder.FirstName === '' || this.shareholder.LastName === '') {
        this.$f7.alert(this.$i18n.t('errors.shareholders_name_mandatory'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      if (parseInt(this.shareholder.PercentageDetention) < 25) {
        this.$f7.alert(this.$i18n.t('errors.percentage_detention_too_low'), this.$i18n.t('errors.errors_in_form'))
        return
      }

      let documentInformations = {}
      let attributes = Object.keys(this.document.Serialize)
      for (var j = 0; j < attributes.length; j++) {
        if (typeof this.document.Serialize[attributes[j]] === 'object') {
          documentInformations[attributes[j]] = this.document.Serialize[attributes[j]].Value
        } else {
          documentInformations[attributes[j]] = this.document.Serialize[attributes[j]]
        }
      }
      this.$f7.showPreloader(this.$i18n.t('loading.sending_document_UBO'))
      let fileContentToSend = this.fileArray[0].Content
      if (this.fileArray.length > 1) {
        for (let i = 1; i < this.fileArray.length; i++) {
          fileContentToSend += ';' + this.fileArray[i].Content.substring(this.fileArray[i].Content.indexOf(',') + 1)
        }
      }
      let that = this
      if (this.shareholder !== false && this.shareholder.IdUBO === undefined && that.idShareholder === '') {
        // Adding UBO if it is a new id
        that.$engine.services.suppliers.addUBO({
          Siren: that.seller.Siren,
          IdExchangeGroup: that.seller.IdGroupDocument,
          UBO: {
            LastName: that.shareholder.LastName,
            FirstName: that.shareholder.FirstName,
            PercentageDetention: that.shareholder.PercentageDetention,
            IsLegalRepresentative: that.shareholder.IsLegalRepresentative
          }
        })
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            that.idShareholder = response.data.IdUBO
            that.$engine.services.suppliers.uploadDocument({
              IdDocument: that.document.Type === 'IDCARD' ? response.data.IdDocumentBeneficialCNI : response.data.IdDocumentBeneficialProofOfAddress,
              IdSeller: that.seller.IdSeller,
              DocumentType: that.document.Type,
              DocumentName: that.fileArray[0].Name,
              ocr: '0',
              DocumentData: fileContentToSend,
              Serialize: documentInformations
            })
            .then(response => {
              that.status = response.status
              if (response.status === 200) {
                that.$f7.hidePreloader()
                that.$f7.modal({
                  title: that.$i18n.t('success.UBO_added_document_sent'),
                  text: '<i class="icon fa fa-check"></i>'
                })
                this.document.Status = '11'
                let attributes = Object.keys(this.document.Serialize)
                for (var j = 0; j < attributes.length; j++) {
                  if (typeof this.document.Serialize[attributes[j]] === 'object') {
                    this.document.Serialize[attributes[j]] = this.document.Serialize[attributes[j]].Value
                  }
                }
                this.fileArray = [{'Name': response.data.DocumentName, 'Content': response.data.DocumentData}]
                setTimeout(function () {
                  that.$f7.closeModal()
                }, 2000)
              }
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        that.$engine.services.suppliers.uploadDocument({
          IdDocument: that.document.IdDocument,
          IdSeller: that.seller.IdSeller,
          DocumentType: that.document.Type,
          DocumentName: that.fileArray[0].Name,
          ocr: '0',
          DocumentData: fileContentToSend,
          Serialize: documentInformations
        })
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$i18n.t('success.document_sent'),
              text: '<i class="icon fa fa-check"></i>'
            })
            this.document.Status = '11'
            let attributes = Object.keys(this.document.Serialize)
            for (var j = 0; j < attributes.length; j++) {
              if (typeof this.document.Serialize[attributes[j]] === 'object') {
                this.document.Serialize[attributes[j]] = this.document.Serialize[attributes[j]].Value
              }
            }
            this.fileArray = [{'Name': response.data.DocumentName, 'Content': response.data.DocumentData}]
            setTimeout(function () {
              that.$f7.closeModal()
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    }
  }
}
</script>
<style scoped>
.icon-doc-IDCARD {
  content: url("./../../../../assets/static/images/icons/doc_IDCARD.png");
}
.icon-doc-KBIS {
  content: url("./../../../../assets/static/images/icons/doc_KBIS.png");
}
.icon-doc-RIB {
  content: url("./../../../../assets/static/images/icons/doc_RIB.png");
}
.icon-doc-STATUS {
  content: url("./../../../../assets/static/images/icons/doc_STATUS.png");
}

.status-doc-IDCARD {
  height: 70px;
  left: 65%;
  position: absolute;
  top: 110px;
  width: 70px;
}
.status-doc-KBIS, .status-doc-RIB, .status-doc-STATUS {
  height: 70px;
  left: 60%;
  position: absolute;
  top: 130px;
  width: 70px;
}

.documentRefusedStatus {
  color: red;
  font-weight: bold;
}

@media (min-width: 993px) {
  .importFileButton {
    text-align: right;
  }
}

.uploadedDocumentsList {
  margin-top: 15px;
}

</style>



// WEBPACK FOOTER //
// DocumentBlocInfo.vue?366f6f3a